import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'datesDuration',
    standalone: false
})
export class DatesDurationPipe implements PipeTransform {

    transform(fromDate: Date | string, toDate?: Date | string, includes?: boolean, unit: 'days' | 'months' = 'days'): string {
        const to = toDate ? new Date(toDate) : new Date();
        const from = fromDate ? new Date(fromDate) : new Date();
        if (unit === 'months') {
            const months = (to.getFullYear() - from.getFullYear()) * 12 + (to.getMonth() - from.getMonth()) + 1;
            return months === 1 ? `${months} month` : `${months} months`;
        }
        const diffTime = Math.abs(to.getTime() - from.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1 - (includes ? 0 : 1);
        return diffDays === 1 ? `${diffDays} day` : `${diffDays} days`;
    }

}
